module.exports = __webpack_public_path__ + "static/img/banner-caption.2f7e272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-caption.png
// module id = 7Qbi
// module chunks = 1